import React, { useEffect, useState, createElement } from 'react';
import { Calendar, CheckCircle, Users, ArrowRight } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
declare global {
  interface Window {
    fbq: any;
  }
}
export function BookingQualificationPage() {
  const [showSurvey, setShowSurvey] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — fire only
    // this page's unique events to avoid double-counting.
    if (window.fbq) {
      window.fbq('trackCustom', 'Book-Call-PV');
      window.fbq('trackCustom', 'Book-Call-Page');
    }
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/1n1c7tnsqb.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    const wistiaStyle = document.createElement('style');
    wistiaStyle.textContent = `wistia-player[media-id='1n1c7tnsqb']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1n1c7tnsqb/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(wistiaStyle);
    // Load GHL form embed script
    const formScript = document.createElement('script');
    formScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formScript.async = true;
    document.head.appendChild(formScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(wistiaStyle);
      if (document.head.contains(formScript)) document.head.removeChild(formScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-665" data-mp="11z2shbcus3y4">
      {/* Header */}
      <VslHeader data-id="element-666" data-mp="1pp6tdaynpplf" />

      {/* Hero Section */}
      <section className="pt-20 md:pt-28 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-667" data-mp="1uh86t07k9md1">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-668" data-mp="3f7ly37zx30k7">
          {/* Main Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight text-center tracking-tight" data-id="element-669" data-mp="3a929eztxvao5">
            Agenda Tu Llamada de Claridad
          </h1>

          {/* Wistia Video */}
          <div className="mb-8 rounded-2xl overflow-hidden border-2 border-cyan-500 shadow-2xl" data-id="element-670" data-mp="3jy2d2wjdyu8o">
            <wistia-player media-id="1n1c7tnsqb" aspect="1.7777777777777777" data-id="element-671" data-mp="2w8hq82k43cu4"></wistia-player>
          </div>

          {/* Qualification Message - Highlight Box */}
          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-2xl p-6 md:p-8 border-2 border-cyan-500 mb-8 shadow-2xl" data-id="element-672" data-mp="2rcasuy5s79ns">
            <div className="flex items-start gap-4 mb-4" data-id="element-673" data-mp="317unziciu4bh">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-cyan-400 flex-shrink-0 mt-1" data-id="element-674" data-mp="31agurfrl8fsn" />
              <div data-id="element-675" data-mp="lj2prdh6j4i6">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-676" data-mp="ghvg18vh7v8v">
                  Proceso de Calificación
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-677" data-mp="2m7h1giaaobef">
                  Para poder hablar con nuestro equipo, primero debemos
                  verificar si eres un buen candidato para esta oportunidad. Por
                  favor, completa el formulario a continuación para agendar tu
                  llamada de claridad.
                </p>
              </div>
            </div>
          </div>

          {/* Benefits List */}
          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-678" data-mp="3a3uv8tea5snl">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-679" data-mp="3eutb5rvcwoqb">
              <Users className="w-6 h-6 text-cyan-400" data-id="element-680" data-mp="3iwev1x6b63a0" />
              En esta llamada descubrirás:
            </h3>
            <div className="space-y-3" data-id="element-681" data-mp="3nw19g9xvhpke">
              {['Si 48/hrs AI Cash Machine es adecuado para tu situación actual', 'Cómo implementar el sistema paso a paso en tu negocio', 'Estrategias personalizadas para tu nicho específico', 'Respuestas a todas tus preguntas sobre el programa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-682" data-mp="1ubqqks2ai2u" data-mpi={i}>
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-683" data-mp="1w522ddmdqh6" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-684" data-mp="3t0mzz4786p59">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-6 md:py-8 bg-black" data-id="element-685" data-mp="kkjo0m92yeb4">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-686" data-mp="kluwv0hduc93">
          <button onClick={() => setShowSurvey(true)} className="group relative w-full max-w-xl mx-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl lg:text-2xl uppercase tracking-wide rounded-xl py-5 px-6 shadow-[0_0_30px_rgba(253,185,49,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-687" data-mp="ft1pe4uj4ptb">
            APLICAR PARA LA LLAMADA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-688" data-mp="2xtm1f6s2yixi" />
            <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-689" data-mp="32sfdcurpy1vk">
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-690" data-mp="2nzdo3qbmewjx" />
            </div>
          </button>

          {/* Trust Indicators */}
          <div className="mt-10 text-center" data-id="element-691" data-mp="2k04qubhdggjm">
            <div className="inline-flex items-center gap-2 bg-gray-800/50 border border-gray-700 rounded-full px-6 py-3" data-id="element-692" data-mp="2jxs31hoxnbyn">
              <CheckCircle className="w-5 h-5 text-cyan-400" data-id="element-693" data-mp="2a1fa4m17p24y" />
              <span className="text-gray-200 text-sm md:text-base" data-id="element-694" data-mp="2a1xds3q7eimw">
                100% Confidencial • Sin Compromiso • Llamada Gratuita
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-695" data-mp="1srl61gg5kj29">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-696" data-mp="1ntjjgljiq1m1">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-697" data-mp="1nv304d936eoc">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-698" data-mp="22jz5u3no7fls">
              ¿Qué Esperar de la Llamada?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-699" data-mp="2bht4hl8wqlc4">
              <div className="space-y-3" data-id="element-700" data-mp="27h984jw5rlr1">
                <div className="flex items-start gap-3" data-id="element-701" data-mp="27g7ldi5s5ath">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-702" data-mp="2lh0djw8lzttf">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-703" data-mp="2leo0nxhpk9n8" />
                  </div>
                  <div data-id="element-704" data-mp="2gful7ziv28kf">
                    <p className="font-semibold text-white text-sm" data-id="element-705" data-mp="r2zepbd276tc">
                      Duración: 30-45 minutos
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-706" data-mp="m4xx6uva7fjz">
                      Tiempo suficiente para conocerte
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-707" data-mp="591ybox03f33">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-708" data-mp="57h2zx2v3s46">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-709" data-mp="a1buhmoplbdt" />
                  </div>
                  <div data-id="element-710" data-mp="ez3oqnctt9l6">
                    <p className="font-semibold text-white text-sm" data-id="element-711" data-mp="f1hh2og4g7p1">
                      Formato: Video llamada
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-712" data-mp="3ifk6bj30hnja">
                      Conexión personal y directa
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-713" data-mp="3sf2qo0mu3bbv">
                <div className="flex items-start gap-3" data-id="element-714" data-mp="3sfujj3p1quyg">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-715" data-mp="12q0nszjiwcf0">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-716" data-mp="17o28fowlkjsl" />
                  </div>
                  <div data-id="element-717" data-mp="2s6cy80cll839">
                    <p className="font-semibold text-white text-sm" data-id="element-718" data-mp="2s6mhz671uj0i">
                      Sin presión de venta
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-719" data-mp="2n81r3xdotboq">
                      Solo asesoría honesta
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-720" data-mp="2dgf8hfz0saby">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-721" data-mp="28idp0txom8zy">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-722" data-mp="28g9cjnlpw1o2" />
                  </div>
                  <div data-id="element-723" data-mp="24fh4gxol02td">
                    <p className="font-semibold text-white text-sm" data-id="element-724" data-mp="1zhnya4na38t3">
                      Plan personalizado
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-725" data-mp="1ujdx9devhdzk">
                      Adaptado a tu situación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-726" data-mp="1bre2pz1fkcnn" />

      {/* Floating WhatsApp Button */}
      <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-all duration-300" aria-label="Chat on WhatsApp" data-id="element-727" data-mp="1bpt869f48tps">
        <svg className="w-8 h-8 md:w-9 md:h-9 text-white" viewBox="0 0 24 24" fill="currentColor" data-id="element-728" data-mp="t16702028ohh">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-729" data-mp="o21zdfssayt9" />
        </svg>
      </a>

      {/* Survey Modal */}
      {showSurvey && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowSurvey(false)} data-id="element-730" data-mp="8z1ugd5ezpsv">
          <div className="relative w-full max-w-2xl bg-[#111] border border-cyan-500/30 rounded-2xl shadow-[0_0_30px_rgba(0,247,252,0.15)] p-4 md:p-6" onClick={e => e.stopPropagation()} data-id="element-731" data-mp="2opemg5f8y4iz">
            <button onClick={() => setShowSurvey(false)} className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" data-id="element-732" data-mp="106tqag7jknsx">
              ✕
            </button>
            <div className="w-full rounded-xl overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-733" data-mp="qenzh9t10cfb">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/GeSFJtaO6Zp1TrdO74Qf" style={{
            border: 'none',
            width: '100%',
            height: '600px'
          }} scrolling="no" id="GeSFJtaO6Zp1TrdO74Qf" title="survey" data-id="element-734" data-mp="gikulw6shzoo" />
            </div>
          </div>
        </div>}
    </div>;
}